import { Flex, Spacing, Text } from '@billy/design-system'
import { ReactNode } from 'react'

import * as Styled from './styles'

interface DrawerSectionProps {
  title: string
  children: ReactNode
  action?: ReactNode
  gap?: Spacing | false
}

export const DrawerSection = ({ title, children, action, gap = Spacing.S8 }: DrawerSectionProps) => (
  <Styled.SectionWrapper>
    <Flex flexDirection="column" gap={gap || undefined}>
      <Flex justifyContent="space-between" alignItems="center">
        <Text weight="medium">{title}</Text>
        {action}
      </Flex>
      {children}
    </Flex>
  </Styled.SectionWrapper>
)
